export interface CommentOrReport {
  content: string;
  description: string;
  filename: string;
  url: string;
  amazonKey: string;
  bucketName: string;
  documentType: string;
  documentStatus: string;
  createdOn: string;
  createdByFirstName: string;
  createdByLastName: string;
  id: number;
  amazonId: string;
  subjectLine: string;
  reportStatusTC: string;
  isOnline: boolean;
  isForPreview: boolean;
  mimeType: string;
  approved?: boolean;
  VirusDetected?: boolean;
  AVScanned?: boolean;
  hasBeenQueued: boolean;
}

export function createCommentOrReportRequest(): CommentOrReport {
  return {
    content: '',
    description: '',
    filename: '',
    url: '',
    amazonKey: '',
    bucketName: '',
    documentType: '',
    documentStatus: '',
    createdOn: '',
    createdByFirstName: '',
    createdByLastName: '',
    id: 0,
    amazonId: '',
    subjectLine: '',
    reportStatusTC: '',
    isOnline: false,
    isForPreview: false,
    mimeType: '',
    hasBeenQueued: false,
  };
}

export function createCommentOrReport(): CommentOrReport {
  return {
    content: '',
    reportStatusTC: '',
    subjectLine: '',
    description: '',
    filename: '',
    url: '',
    amazonKey: '',
    bucketName: '',
    documentType: '',
    documentStatus: '',
    createdOn: '',
    createdByFirstName: '',
    createdByLastName: '',
    id: 0,
    amazonId: '',
    isOnline: false,
    isForPreview: false,
    mimeType: '',
    approved: false,
    hasBeenQueued: false,
  };
}